// utils/timeZones.js
import moment from 'moment-timezone';

/** 1) Canonical IANA zones – always safe */
const canonical = moment.tz.names().map((tz) => ({
  value: tz,                                  // what Luxon / server will use
  label: `${tz} (${moment.tz(tz).format('z')})`,
}));

/** 2) Legacy aliases that often break on servers */
const ALIAS_MAP = {
  'Canada/Eastern':  'America/Toronto',
  'Canada/Central':  'America/Winnipeg',
  'Canada/Mountain': 'America/Edmonton',
  'Canada/Pacific':  'America/Vancouver',
  'Canada/Atlantic': 'America/Halifax',
  'Canada/Newfoundland': 'America/St_Johns',
  'Canada/Saskatchewan': 'America/Regina',
  'Canada/Yukon': 'America/Whitehorse',
  // add more if you ever need them
};

const aliases = Object.entries(ALIAS_MAP).map(([alias, canonicalId]) => ({
  value: canonicalId,                                 // send canonical!
  label: `${alias} (${moment.tz(canonicalId).format('z')})`,
}));

/** 3) One merged, deduplicated list */
const seen = new Set();                 // avoid duplicate labels
const timeZones = [...canonical, ...aliases].filter(({ label }) => {
  if (seen.has(label)) return false;
  seen.add(label);
  return true;
});

export default timeZones;
